<template>
  <div class="app-container">
    <el-row :gutter="20">
      <el-col :span="24">
        <el-form :model="queryParams" ref="queryParams" size="small" label-width="100px">
          <!-- 搜索条件 -->
          <el-row :gutter="20">
            <el-col :span="4">
              <el-form-item label="认领状态">
                <el-select v-model="queryParams.claimStatus" placeholder="请选择认领状态" style="width: 100%" @change="handleSearch">
                  <el-option label="已认领" value="0" />
                  <el-option label="未认领" value="1" />
                  <el-option label="全部" value="-1" />
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="4">
              <el-form-item label="到检月份">
                <el-date-picker v-model="queryParams.inspectionMonthList" type="months" placeholder="请选择到检月份" value-format="yyyy-MM" style="width: 100%"  />
              </el-form-item>
            </el-col>
            <el-col :span="4">
              <el-form-item label="客户名称">
                <el-input v-model="queryParams.compNames" placeholder="请输入客户名称" @keyup.enter.native="handleSearch" />
                <CustomerDetails v-model="queryParams.compNames" />
              </el-form-item>
            </el-col>
            <el-col :span="4">
              <el-form-item label="使用单位">
                <el-input v-model="queryParams.usingUnit" placeholder="请输入使用单位" clearable @keyup.enter.native="handleSearch" />
              </el-form-item>
            </el-col>
            <el-col :span="4">
              <el-form-item label="小区名称">
                <el-input v-model="queryParams.houseName" placeholder="请输入小区名称" clearable @keyup.enter.native="handleSearch" />
              </el-form-item>
            </el-col>
            <el-col :span="4">
              <el-form-item label="电梯识别码">
                <el-input v-model="queryParams.OIDNO" placeholder="请输入电梯识别码" clearable @keyup.enter.native="handleSearch" />
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="20">
            <el-col :span="6">
              <el-form-item label="设备地址">
                <el-input v-model="queryParams.EQP_USE_ADDR" placeholder="请输入设备地址" clearable @keyup.enter.native="handleSearch" />
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="登记日期">
                <el-date-picker v-model="queryParams.registrationDate" type="daterange" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" format="yyyy-MM-dd"
                                value-format="yyyy-MM-dd" clearable style="width: 100%" @change="handleSearch" />
              </el-form-item>
            </el-col>
          </el-row>
          <div style="text-align: center;margin-bottom: 10px;">
            <PermissionMethodToolbar :url="url" :id="'toolbar'" @handleSearch="handleSearch" @handleAdd="handleAdd" @handleModify="handleModify" @handleBatchModify="handleBatchModify"
                                     @handleBatchDelete="handleBatchDelete" @handleClaim="handleClaim" @handleExport="handleExport" @handleClaimCancel="handleClaimCancel" />
          </div>
          <!-- 添加遮罩层和加载状态的表格 -->
          <el-table :data="tableData" border style="width: 100%; margin-top: 20px" v-loading="loading" element-loading-text="正在查询数据..." element-loading-spinner="el-icon-loading"
                    element-loading-background="rgba(0, 0, 0, 0.8)" @selection-change="handleSelectionChange" height="600">
            <el-table-column type="selection" width="55" fixed="left"></el-table-column>
            <el-table-column type="index" label="序号" width="60" align="center" fixed="left" />
            <el-table-column label="识别码" prop="OIDNO" show-overflow-tooltip fixed="left" width="100" />
            <el-table-column label="客户名称" prop="compName" show-overflow-tooltip fixed="left" width="200" />
            <el-table-column label="现场联系人及电话" prop="siteContactAndTel" show-overflow-tooltip width="160" />
            <el-table-column label="使用单位名称" prop="usingUnit" show-overflow-tooltip width="160" />
            <el-table-column label="小区名称" prop="houseName" show-overflow-tooltip />
            <el-table-column label="到检年月" prop="inspectionMonth" show-overflow-tooltip />
            <el-table-column label="社会信用代码" prop="unifiedCreditCode" show-overflow-tooltip width="160" />
            <el-table-column label="单位使用地址" prop="USE_UNT_ADDR" show-overflow-tooltip width="160" />
            <el-table-column label="设备地址" prop="EQP_USE_ADDR" show-overflow-tooltip width="160" />
            <el-table-column label="业务联系人及电话" prop="businessContactAndTel" show-overflow-tooltip width="160" />
            <el-table-column label="折扣" prop="finalDisc" show-overflow-tooltip width="80" />
            <el-table-column label="固定价" prop="finalPrice" show-overflow-tooltip width="90" />
            <el-table-column label="检测费用" prop="finalPrice" show-overflow-tooltip width="100" />
            <el-table-column label="认领日期" show-overflow-tooltip width="120">
              <template slot-scope="scope">
                {{ scope.row.claimStatus == '0' ? (scope.row.claimDate || '') : '' }}
              </template>
            </el-table-column>
            <el-table-column label="认领状态" prop="claimStatus" width="100">
              <template slot-scope="scope">
                <span :class="['status-text', scope.row.claimStatus == '0' ? 'status-claimed' : 'status-unclaimed']">
                  {{ getClaimStatusText(scope.row.claimStatus) }}
                </span>
              </template>
            </el-table-column>
            <el-table-column label="登记日期" prop="registrationDate" show-overflow-tooltip width="100" />
            <el-table-column label="委托单编号" prop="entrustNum" show-overflow-tooltip width="180" />
            <el-table-column label="备注" prop="remark" show-overflow-tooltip />
            <el-table-column label="操作" fixed="right" width="180">
              <template slot-scope="scope">
                <PermissionMethodRow :url="url" :id="'rowtoolbar'" :disabledButtons="getDisabledButtons(scope.row)" @handleEdit="handleEdit(scope.row)" @handleRowDelete="handleRowDelete(scope.row)"
                                     @handleEditClaimDate="handleEditClaimDate(scope.row)" />
              </template>
            </el-table-column>
          </el-table>
          <el-pagination v-show="total > 0" @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="queryParams.currPage" :page-sizes="[10, 20, 50, 100,1000]"
                         :page-size="queryParams.pageSize" layout="total, sizes, prev, pager, next, jumper" :total="total" style="margin-top: 20px; text-align: right;">
          </el-pagination>
        </el-form>
      </el-col>
    </el-row>

    <!-- 新增/修改弹出层 -->
    <AddAndEdit ref="addAndEdit" @refresh="handleQuery" />

    <!-- 认领弹出层 -->
    <ClaimDialog ref="claimDialog" @refresh="handleQuery" />
  </div>
</template>

<script>
import { queryEntrustList, deleteEntrustInfo, exportEntrList, cancelClaimInfos } from '@/api/contract/contract'
import AddAndEdit from './AddAndEdit.vue'
import ClaimDialog from './ClaimDialog.vue'
import PermissionMethodToolbar from '@/components/button/PermissionMethodToolbar.vue'
import PermissionMethodRow from '@/components/button/PermissionMethodRow.vue'

export default {
  components: {
    AddAndEdit,
    ClaimDialog,
    PermissionMethodToolbar,
    PermissionMethodRow
  },
  props: {
    url: {
      type: String
    }
  },
  data () {
    return {
      queryParams: {
        usingUnit: '',
        inspectionMonthList: [],
        houseName: '',
        claimStatus: '1', // 默认未认领
        currPage: 1,
        pageSize: 1000,
        registrationDate: [],
        EQP_USE_ADDR: ''
      },
      tableData: [],
      total: 0,
      loading: false,
      selectedRows: []
    }
  },
  created () {
    // this.handleQuery()
  },
  methods: {
    handleSearch () {
      this.queryParams.currPage = 1
      this.handleQuery()
    },
    handleQuery () {
      this.loading = true
      const params = { ...this.queryParams }

      // if (params.registrationDate && params.registrationDate.length) {
      //   params.registrationDate = params.registrationDate.join(',')
      // }

      queryEntrustList(params).then(res => {
        this.tableData = res.additionalData?.records || []
        this.total = res.additionalData?.total || 0
        this.queryParams.currPage = res.additionalData?.current
        this.queryParams.pageSize = res.additionalData?.size
        this.loading = false
      }).catch(err => {
        this.$message.error(err.message || '查询失败')
        this.loading = false
      })
    },
    handleAdd () {
      this.$refs.addAndEdit.showAdd()
    },
    handleExport () {
      this.$message.info('正在导出...')
      const params = { ...this.queryParams }
      exportEntrList(params).then(response => {
        let blob
        if (response instanceof Blob) {
          blob = response
        } else if (response && response.data instanceof Blob) {
          blob = response.data
        } else {
          blob = new Blob([response], {
            type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
          })
        }
        if (blob.type && blob.type.includes('application/json')) {
          const reader = new FileReader()
          reader.onload = () => {
            try {
              const errorData = JSON.parse(reader.result)
              this.$message.error(errorData.retMsg || errorData.message || '导出失败')
            } catch (e) {
              this.$message.error('导出失败')
            }
          }
          reader.readAsText(blob)
          return
        }
        const url = window.URL.createObjectURL(blob)
        const link = document.createElement('a')
        link.href = url
        link.download = `委托列表_${new Date().getTime()}.xlsx`
        link.style.display = 'none'
        document.body.appendChild(link)
        link.click()
        document.body.removeChild(link)
        window.URL.revokeObjectURL(url)
        this.$message.success('导出成功')
      }).catch(err => {
        this.$message.error(err.message || '导出失败')
      })
    },
    handleClaimCancel () {
      // 认领撤销：监管未下载确认成功前，可将已认领数据改为已撤销
      if (this.selectedRows.length === 0) {
        this.$message.warning('请先选择要认领撤销的数据')
        return
      }
      const unclaimedRows = this.selectedRows.filter(row => row.claimStatus != '0')
      if (unclaimedRows.length > 0) {
        const oidnoList = unclaimedRows.map(item => item.OIDNO).join('、')
        this.$message.warning(`选中数据中识别码 "${oidnoList}" 不是已认领状态，无法撤销`)
        return
      }
      // jgUpdState=0 表示已确认/已下载，不允许撤销
      const downloadedItems = this.selectedRows.filter(item => item.jgUpdState == '0' || item.jgUpdState === 0)
      if (downloadedItems.length > 0) {
        const oidnoList = downloadedItems.map(item => item.OIDNO).join('、')
        this.$message.warning(`选中数据中识别码 "${oidnoList}" 已完成监管下载确认，不允许认领撤销`)
        return
      }
      const missingEntrNum = this.selectedRows.filter(item => !item.entrustNum)
      if (missingEntrNum.length > 0) {
        const oidnoList = missingEntrNum.map(item => item.OIDNO).join('、')
        this.$message.warning(`选中数据中识别码 "${oidnoList}" 缺少委托单编号，无法撤销`)
        return
      }
      const oidnoList = this.selectedRows.map(item => item.OIDNO).join('、')
      const confirmMsg = this.selectedRows.length > 1
        ? `已选择 ${this.selectedRows.length} 条数据（识别码：${oidnoList}），确定要认领撤销吗？`
        : `确定要撤销识别码为 "${this.selectedRows[0].OIDNO}" 的认领吗？`
      this.$confirm(confirmMsg, '确认认领撤销', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        const entrNums = this.selectedRows.map(item => item.entrustNum)
        cancelClaimInfos({ entrNums }).then(res => {
          if (res && res.retCode === 'ok') {
            this.$message.success(res.retMsg || '认领撤销成功')
            this.handleQuery()
          } else {
            this.$message.error(res.retMsg || '认领撤销失败')
          }
        }).catch(err => {
          this.$message.error(err.message || '认领撤销失败')
        })
      }).catch(() => { })
    },
    handleModify () {
      // 整批修改 - 基于选中行的batchNum，只能选一条
      if (this.selectedRows.length === 0) {
        this.$message.warning('请先选择要修改的数据')
        return
      }
      if (this.selectedRows.length > 1) {
        this.$message.warning('整批修改只能选择一条数据')
        return
      }
      const row = this.selectedRows[0]
      if (row.receiveStatus == '1' || row.receiveStatus === 1) {
        this.$message.warning('该记录已收款，不允许修改')
        return
      }
      if (!row.batchNum) {
        this.$message.warning('该记录没有批次号，无法进行整批修改')
        return
      }
      this.$refs.addAndEdit.showEdit(row)
    },
    handleBatchModify () {
      // 批量修改 - 基于勾选数据，不限制条数，直接回填到编辑弹窗
      if (this.selectedRows.length === 0) {
        this.$message.warning('请先选择要批量修改的数据')
        return
      }
      this.$refs.addAndEdit.showBatchEdit(this.selectedRows)
    },
    handleBatchDelete () {
      // 批量删除 - 基于选中行的custPid
      if (this.selectedRows.length === 0) {
        this.$message.warning('请先选择要删除的数据')
        return
      }
      const invalidRows = this.selectedRows.filter(item => !item.custPid)
      if (invalidRows.length > 0) {
        const oidnoList = invalidRows.map(item => item.OIDNO).join('、')
        this.$message.warning(`选中数据中识别码 "${oidnoList}" 缺少数据标识，无法删除`)
        return
      }
      const custPidList = this.selectedRows.map(item => item.custPid)
      const runDelete = () => {
        deleteEntrustInfo(custPidList).then(res => {
          if (res && res.retCode === 'ok') {
            this.$message.success(res.retMsg)
            this.handleQuery()
          } else {
            this.$message.error(res.retMsg || '删除失败')
          }
        }).catch(err => {
          this.$message.error(err.message || '删除失败')
        })
      }
      // 检查选中数据中是否有已完成监管下载的（jgUpdState=0表示已确认/已下载）
      const downloadedItems = this.selectedRows.filter(item => item.jgUpdState == '0' || item.jgUpdState === 0)
      if (downloadedItems.length > 0) {
        const oidnoList = downloadedItems.map(item => item.OIDNO).join('、')
        this.$confirm(
          `选中数据中识别码 "${oidnoList}" 已完成监管下载，删除后数据将无法恢复，是否确认删除？`,
          '提示',
          {
            confirmButtonText: '是',
            cancelButtonText: '否',
            type: 'warning'
          }
        ).then(() => {
          runDelete()
        }).catch(() => { })
        return
      }
      const oidnoList = this.selectedRows.map(item => item.OIDNO).join('、')
      const confirmMsg = this.selectedRows.length > 1
        ? `已选择 ${this.selectedRows.length} 条数据（识别码：${oidnoList}），确定要删除吗？`
        : `确定要删除识别码为 "${this.selectedRows[0].OIDNO}" 的委托信息吗？`
      this.$confirm(confirmMsg, '确认删除', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        runDelete()
      }).catch(() => { })
    },
    handleClaim () {
      // 认领确认：未认领(1)、已撤销(2) 可认领；已认领(0) 不可重复认领
      if (this.selectedRows.length === 0) {
        this.$message.warning('请先选择要认领的数据')
        return
      }
      const hasClaimedData = this.selectedRows.some(row => row.claimStatus == '0')
      if (hasClaimedData) {
        this.$message.warning('选中的数据中有已认领的数据，不允许重复认领')
        return
      }
      this.$refs.claimDialog.show(this.selectedRows, 'claim')
    },
    handleEdit (row) {
      // 单行修改 - 只修改当前这一条数据
      if (row.receiveStatus == '1' || row.receiveStatus === 1) {
        this.$message.warning('该记录已收款，不允许修改')
        return
      }
      // 检查是否已完成监管下载（jgUpdState=0表示已确认/已下载）
      // if (row.jgUpdState == '0' || row.jgUpdState === 0) {
      //   this.$message.warning(`识别码 "${row.OIDNO}" 已完成监管下载，不允许修改`)
      //   return
      // }
      if (!row.custPid) {
        this.$message.warning('该记录缺少数据标识，无法进行修改')
        return
      }
      this.$refs.addAndEdit.showEditSingle(row)
    },
    handleRowDelete (row) {
      // 单行删除 - 只删除当前这一条数据
      // 检查是否已完成监管下载（jgUpdState=0表示已确认/已下载）
      if (row.jgUpdState == '0' || row.jgUpdState === 0) {
        this.$message.warning(`识别码 "${row.OIDNO}" 已完成监管下载，不允许删除`)
        return
      }
      if (!row.custPid) {
        this.$message.warning('该记录缺少数据标识，无法删除')
        return
      }
      this.$confirm(`确定要删除识别码为 "${row.OIDNO}" 的委托信息吗？`, '确认删除', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        deleteEntrustInfo([row.custPid]).then(res => {
          console.log('删除响应:', res)
          if (res && res.retCode === 'ok') {
            this.$message.success('删除成功')
            this.handleQuery()
          } else {
            this.$message.error(res.retMsg || '删除失败')
          }
        }).catch(err => {
          console.error('删除失败:', err)
          this.$message.error(err.message || '删除失败')
        })
      })
    },
    handleEditClaimDate (row) {
      // 修改认领日期：仅已认领可改；监管已下载不可改
      if (row.claimStatus != '0') {
        this.$message.warning(`识别码 "${row.OIDNO}" 不是已认领状态，无法修改认领日期`)
        return
      }
      if (row.jgUpdState == '0' || row.jgUpdState === 0) {
        this.$message.warning(`识别码 "${row.OIDNO}" 已完成监管下载，不允许修改认领日期`)
        return
      }
      this.$refs.claimDialog.show([row], 'edit')
    },
    handleSelectionChange (selection) {
      this.selectedRows = selection
    },
    handleSizeChange (val) {
      this.queryParams.pageSize = val
      this.queryParams.currPage = 1
      this.handleQuery()
    },
    handleCurrentChange (val) {
      this.queryParams.currPage = val
      this.handleQuery()
    },
    getClaimStatusText (status) {
      // 2-已撤销 前端统一显示为未认领
      return status == '0' ? '已认领' : '未认领'
    },
    getDisabledButtons (row) {
      const disabled = []
      // 非已认领：不显示「修改认领日期」
      if (row.claimStatus != '0') {
        disabled.push('handleEditClaimDate')
      }
      return disabled
    }
  }
}
</script>

<style scoped>
.status-text {
  font-weight: 500;
}

.status--1 {
  color: orange;
}

.status-0 {
  color: green;
}

.status-1 {
  color: black;
}

.status-2 {
  color: red;
}

.status-claimed {
  color: green;
}

.status-unclaimed {
  color: #909399;
}

::v-deep .el-table__body-wrapper {
  z-index: 2;
}
</style>
